var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-9"},[_c('v-btn',{attrs:{"color":"primary","href":_vm.url,"target":"_blank"}},[_vm._v("Let's Go!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }